export default __webpack_public_path__ + "static/media/blush-soft-summer.6c50e68f.png";